export type OwnitFontId = 'Nanum Gothic' | 'Nanum Myeongjo' | 'Typewriter';

export interface OwnitFontOption {
    id: OwnitFontId;
    label: string;
    description: string;
    sample: string;
    cssFamily: 'OwnitNanumGothic' | 'OwnitNanumMyeongjo' | 'OwnitTypewriter';
    role: 'body' | 'brand-special';
}

export const OWNIT_DEFAULT_FONT_ID: OwnitFontId = 'Nanum Gothic';

export const OWNIT_FONT_OPTIONS: OwnitFontOption[] = [
    {
        id: 'Nanum Gothic',
        label: 'Nanum Gothic',
        description: '앱 본문 기본값에 맞는 또렷한 고딕체',
        sample: '오늘 09:30 / ABC 123 !?',
        cssFamily: 'OwnitNanumGothic',
        role: 'body'
    },
    {
        id: 'Nanum Myeongjo',
        label: 'Nanum Myeongjo',
        description: '한글 일정과 기록에 부드러운 명조체',
        sample: '오늘 09:30 / ABC 123 !?',
        cssFamily: 'OwnitNanumMyeongjo',
        role: 'body'
    },
    {
        id: 'Typewriter',
        label: 'Typewriter',
        description: 'Ownit 브랜드와 인증 입력값용 타자기체',
        sample: 'OWNIT 09:30 / ABC 123 !?',
        cssFamily: 'OwnitTypewriter',
        role: 'brand-special'
    }
];

export function normalizeOwnitFontId(fontId: string | null | undefined): OwnitFontId {
    const normalized = (fontId || '').trim();
    if (!normalized || normalized === 'SUIT') return OWNIT_DEFAULT_FONT_ID;
    if (normalized === 'Nanum Gothic' || normalized === 'NanumGothic' || normalized === 'OwnitNanumGothic') return 'Nanum Gothic';
    if (normalized === 'Nanum Myeongjo' || normalized === 'NanumMyeongjo' || normalized === 'OwnitNanumMyeongjo') return 'Nanum Myeongjo';
    if (normalized === 'Typewriter' || normalized === 'OwnitTypewriter') return 'Typewriter';
    return OWNIT_DEFAULT_FONT_ID;
}

export function ownitFontStack(fontId: string | null | undefined): string {
    const normalized = normalizeOwnitFontId(fontId);
    if (normalized === 'Nanum Myeongjo') {
        return 'OwnitNanumMyeongjo, "Nanum Myeongjo", "Noto Serif KR", Batang, "AppleMyungjo", serif';
    }
    if (normalized === 'Typewriter') {
        return 'OwnitTypewriter, OwnitNanumGothic, "Nanum Gothic", "Courier New", Courier, monospace';
    }
    return 'OwnitNanumGothic, "Nanum Gothic", "Apple SD Gothic Neo", "Malgun Gothic", SUIT, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
}
